import React from "react";
import IPage from "../../interfaces/page"
import BookingsComponent from "../../components/Bookings/Bookings.component";

const BookingsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <BookingsComponent></BookingsComponent>;
};

export default BookingsPage;
